const getNormSets = (data) => ({
  method: "GET",
  url: "/norm_sets",
  data,
});

export const normSetsApi = {
  getNormSets,
};
